import React, { Component } from 'react';
import { connect } from 'react-redux';
import PageTemplate from '../../components/PageTemplate/PageTemplate';
import PrimaryButtonIcon from '../../components/PrimaryButtonIcon/PrimaryButtonIcon';
import { forwardToInput } from '../../redux/actions/result.action';
import ResultAnswere from '../../components/ResultAnswer/ResultAnswer';
import { setTextToSpeak } from '../../redux/actions/text.action';
import './SubResultScreen.scss';

//text
import assistantText from '../../assets/text/text.json';

//icons
import thumpdownIcon from '../../assets/thump_down.png';

class SubResultScreen extends Component<{ navigateTo: any, active: string, searchTerm: string, speak: any, suggestions: any, forward: any, setCurrentpage: any }, {}> {

    private generateAnsweres() {
        return this.props.suggestions.slice(0, 4).map((value: any, key: any) => {
            return (
                <ResultAnswere input={value.displayText} key={key} />
            )
        })
    }

    private renderBody() {
        return (
            <div className="container">
                <div className="subresult-answeres">
                    {this.generateAnsweres()}
                </div>
                <PrimaryButtonIcon icon={thumpdownIcon} text="Lieber noch ein Wort" action={() => {
                    this.props.forward();
                }} />
            </div>

        )
    }

    /**
     * inject the searchterm in the text of the assistant
     */
    private includeSearchTerm(inputText: string) {
        return inputText.replace('%input', this.props.searchTerm.toUpperCase());
    }

    /**
     * Main render method of component
     */
    render() {


        let results = [];
        if (this.props.suggestions.length > 0) {
            this.props.suggestions[0] = {
                displayText: this.props.searchTerm
            }
            for (let i = 0; i < 4; i++) {
                const element: any = this.props.suggestions[i];
                if(element) {
                    results.push(element.displayText);
                }
            }
            results.push('Lieber noch ein Wort.')
        }

        return (
            <div className="subresultscreen">
                <PageTemplate assistantLine1={this.includeSearchTerm(assistantText.completionScreen.Assistant.line1)} assistantLine2="" body={this.renderBody()} text={results} />
            </div>
        );
    }
}

const mapStateToProps = (state: any) => {
    return {
        active: state.result.active,
        searchTerm: state.result.searchTerm,
        suggestions: state.result.suggestions
    };
};

const mapDispatchToProps = (dispatch: any) => {
    return {
        forward() {
            dispatch(forwardToInput());
        },
        speak(text: string) {
            dispatch(setTextToSpeak(text))
        }
    }
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SubResultScreen);